var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.iconComponent,{tag:"component",class:_vm.className,style:({ fill: _vm.color })})
}
var staticRenderFns = []

export { render, staticRenderFns }